import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AtalhoMenuGerencial, ModuloGerencial } from '../../core/rotas/navegacao-menu-gerencial';

@Component({
  selector: 'app-painel-dashboard-gerencial',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './painel-dashboard-gerencial.component.html',
  styleUrls: ['../servidor/painel-dashboard-servidor.component.css', './painel-dashboard-gerencial.component.css']
})
export class PainelDashboardGerencialComponent {
  @Input() identificacao = '';
  @Input() atalhos: AtalhoMenuGerencial[] = [];
  @Output() selecionar = new EventEmitter<ModuloGerencial>();
}
